import { render, staticRenderFns } from "./TeamChallengeAdminDashboard.vue?vue&type=template&id=2b102520&scoped=true&"
import script from "./TeamChallengeAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./TeamChallengeAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeamChallengeAdminDashboard.vue?vue&type=style&index=0&id=2b102520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b102520",
  null
  
)

export default component.exports